import { Button, ButtonVariant } from '../elements/Button';

const PageNotFound = () => {
  return (
    <div className='w-full h-screen flex items-center justify-center flex-col'>
      <div className='font-medium font-md w-[550px] text-center'>
        Issue loading, please try again later. If the issue persists, please
        contact Customer Support.
      </div>
      <div className='mt-8'>
        <Button
          variant={ButtonVariant.Default}
          label='Return To Home'
          onClick={() => window.close()}
        />
      </div>
    </div>
  );
};

export default PageNotFound;
